/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC, useEffect, useState } from 'react'
import CN from 'classnames'

import { Badge } from 'components/atoms/Badge'
import { Button } from 'components/atoms/Button'
import { Drawer } from 'components/atoms/Drawer'
import { JsonLoader } from 'components/atoms/JsonLoader'
import { IntegrationPanelView } from 'components/molecules/IntegrationPanel'

export interface ViewPartnerProps {
  className?: string | undefined
  [x: string]: any
}

export const ViewPartner: FC<ViewPartnerProps> = ({
  className,
  isActive,
  notify,
  onCloseClick,
  selectedRowByButtonAction,
  setDeletePartnerPopOutIsOpen,
  setPartnerIntegrationDrawerIsOpen,
  setUpdatePartnerDrawerIsOpen,
  useGetPartnerById,
  useGetPartnerIntegrationById,
}: ViewPartnerProps) => {
  const [viewPartnerDetails, setViewPartnerDetails] = useState<any>({
    status: true,
    partnerName: '',
    partnerCode: '',
    contactPerson: '',
    contactEmail: '',
    supportEmail: '',
    phoneNo: '',
    streetAddress: '',
    suburb: '',
    state: '',
    postalCode: '',
    country: '',
    partnerSLAs: [],
  })

  const { mutate: getPartnerByIdMutate, isLoading: getPartnerByIdIsLoading } =
    useGetPartnerById()

  const {
    mutate: getPartnerIntegrationByIdMutate,
    isLoading: getPartnerIntegrationByIdIsLoading,
  } = useGetPartnerIntegrationById()

  const [newIntegrations, setNewIntegrations] = useState([] as any)

  async function getPartnerById(id: any): Promise<void> {
    getPartnerByIdMutate(
      { id },
      {
        onSuccess: ({ data: successData }: any) => {
          const {
            isActive,
            name,
            code,
            contactName,
            contactEmail,
            supportEmail,
            contactPhone,
            address,
            partnerSLAs = [],
          } = successData.partner

          setViewPartnerDetails({
            partnerId: id,
            status: isActive,
            partnerName: name || '-',
            partnerCode: code || '-',
            contactPerson: contactName || '-',
            contactEmail: contactEmail || '-',
            supportEmail: supportEmail || '-',
            phoneNo: contactPhone || '-',
            streetAddress: address?.lineOne || '-',
            suburb: address?.suburb || '-',
            state: address?.state || '-',
            postalCode: address?.postCode || '-',
            country: {
              value: address?.countryCode,
              label: address?.country || '-',
            },
            partnerSLAs: partnerSLAs || [],
          })
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message, 'error')
          onCloseClick()
        },
      },
    )
  }

  async function getPartnerIntegrationById(id: any): Promise<void> {
    getPartnerIntegrationByIdMutate(
      { id },
      {
        onSuccess: ({ data: successData }: any) => {
          if (successData.detailedPartnerIntegrations.length > 0) {
            const toBeAdded = successData.detailedPartnerIntegrations.map(
              (item: any) => {
                if (item.name === 'Shopify') {
                  return {
                    type: 'existing',
                    id: item.id,
                    newId: '',
                    name: item.name,
                    version: item.apiVersion,
                    isActive: true,
                    extractOrders: item.extractOrders,
                    updateTrackingInfo: item.updateTrackingInfo,
                    updateShippingInfo: item.updateShippingInfo,
                    isStockValidating: item.isStockValidating,
                    warehouses: {
                      value: item.warehouses[0]?.code,
                      label: item.warehouses[0]?.name,
                    },
                    apiBaseUrl: item.baseUrl,
                    apiPassword: item.apiPassword,
                    locationId: item.locationId,
                    enabledSubCarrierAccount: item.enabledSubCarrierAccount,
                  }
                }

                if (item.name === 'Woocommerce') {
                  return {
                    type: 'existing',
                    id: item.id,
                    newId: '',
                    name: item.name,
                    version: item.apiVersion,
                    isActive: true,
                    extractOrders: item.extractOrders,
                    updateTrackingInfo: item.updateTrackingInfo,
                    updateShippingInfo: item.updateShippingInfo,
                    isStockValidating: item.isStockValidating,
                    warehouses: {
                      value: item.warehouses[0]?.code,
                      label: item.warehouses[0]?.name,
                    },
                    apiBaseUrl: item.baseUrl,
                    consumerKey: item.consumerKey,
                    consumerSecret: item.consumerSecret,
                    enabledSubCarrierAccount: item.enabledSubCarrierAccount,
                  }
                }

                if (item.name === 'PushApi') {
                  return {
                    type: 'existing',
                    id: item.id,
                    newId: '',
                    name: item.name,
                    version: item.apiVersion,
                    isActive: true,
                    extractOrders: item.extractOrders,
                    updateTrackingInfo: item.updateTrackingInfo,
                    updateShippingInfo: item.updateShippingInfo,
                    enabledSubCarrierAccount: item.enabledSubCarrierAccount,
                    isStockValidating: item.isStockValidating,
                    sendToBdaPlatform: item.sendToBdaPlatform ?? false,
                    bdaPartnerCode: item.bdaPartnerCode ?? '',
                    bdaWarehouseCode: item.bdaWarehouseCode ?? '',
                    warehouses: {
                      value: item.warehouses[0]?.code,
                      label: item.warehouses[0]?.name,
                    },
                    apiKey: item.apiKey,
                  }
                }

                return null
              },
            )

            setNewIntegrations(toBeAdded.filter(Boolean).slice())
          }
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message, 'error')
          onCloseClick()
        },
      },
    )
  }

  useEffect(() => {
    if (selectedRowByButtonAction?.id) {
      getPartnerById(selectedRowByButtonAction.id)
      getPartnerIntegrationById(selectedRowByButtonAction.id)
    }
  }, [selectedRowByButtonAction?.id])

  const AddPartnerClasses = CN(
    'AddPartner flex flex-col p-6 relative h-full overflow-y-auto overscroll-y-auto',
    className,
    {},
  )

  const ViewSection = (
    heading: string,
    value: string,
    viewAlignment: string,
  ) => {
    return (
      <div
        className={CN('flex flex-col', {
          'w-1/2 pr-2': viewAlignment === 'left',
          'w-1/2 pl-2': viewAlignment === 'right',
          'w-full': viewAlignment === 'full',
        })}>
        <span className='text-N-500 text-sm'>{heading}</span>
        <span className='text-N-700 font-semibold pt-[2px]'>{value}</span>
      </div>
    )
  }

  const getSlaType = (sla: any) =>
    sla.kpiType || sla.KPIType || sla.type || sla.Type || ''

  const getOrderType = (sla: any) => sla.orderType || sla.OrderType || '-'

  const getHours = (sla: any) => sla.hours ?? sla.Hours ?? '-'

  const getCutOffStart = (sla: any) =>
    sla.cutOffTimeStart || sla.CutOffTimeStart || sla.startTime || '-'

  const getCutOffEnd = (sla: any) =>
    sla.cutOffTimeEnd || sla.CutOffTimeEnd || sla.endTime || '-'

  const getDispatchInDays = (sla: any) =>
    sla.dispatchInDays ??
    sla.DispatchInDays ??
    sla.dispatchDays ??
    sla.DispatchDays ??
    '-'

  const getCategory = (sla: any) => sla.category || sla.Category || '-'

  const ViewSLAs = () => {
    const partnerSLAs = viewPartnerDetails.partnerSLAs || []

    const hoursRows = partnerSLAs.filter(
      (sla: any) => getSlaType(sla) === 'DOT_Hours',
    )

    const cutoffRows = partnerSLAs.filter(
      (sla: any) => getSlaType(sla) === 'DOT_Cutoff',
    )

    const dispatchRows = partnerSLAs.filter(
      (sla: any) => getSlaType(sla) === 'DOT_Dispatch',
    )

    return (
      <div className='w-full pt-10'>
        <h2 className='text-lg font-bold text-N-700 mb-4'>Partner SLAs</h2>

        {partnerSLAs.length === 0 && (
          <p className='text-sm text-N-500'>No SLA configured</p>
        )}

        {hoursRows.length > 0 && (
          <div className='mb-6 rounded-md border border-N-200 p-4'>
            <h3 className='mb-3 font-semibold text-N-700'>Based on hours</h3>

            <div className='grid grid-cols-[180px_120px] gap-4 text-sm font-medium text-N-700 mb-2'>
              <span>Order type</span>
              <span>Hours</span>
            </div>

            {hoursRows.map((sla: any, index: number) => (
              <div
                key={`hours-${index}`}
                className='grid grid-cols-[180px_120px] gap-4 text-sm text-N-700 py-1'>
                <span>{getOrderType(sla)}</span>
                <span>{getHours(sla)}</span>
              </div>
            ))}
          </div>
        )}

        {cutoffRows.length > 0 && (
          <div className='mb-6 rounded-md border border-N-200 p-4'>
            <h3 className='mb-3 font-semibold text-N-700'>
              Based on order cut-off time
            </h3>

            <div className='grid grid-cols-[100px_110px_110px_130px_160px] gap-4 text-sm font-medium text-N-700 mb-2'>
              <span>Order type</span>
              <span>Start</span>
              <span>End</span>
              <span>Dispatch in days</span>
              <span>Category</span>
            </div>

            {cutoffRows.map((sla: any, index: number) => (
              <div
                key={`cutoff-${index}`}
                className='grid grid-cols-[100px_110px_110px_130px_160px] gap-4 text-sm text-N-700 py-1'>
                <span>{getOrderType(sla)}</span>
                <span>{getCutOffStart(sla)}</span>
                <span>{getCutOffEnd(sla)}</span>
                <span>{getDispatchInDays(sla)}</span>
                <span>{getCategory(sla)}</span>
              </div>
            ))}
          </div>
        )}

        {dispatchRows.length > 0 && (
          <div className='mb-6 rounded-md border border-N-200 p-4'>
            <h3 className='mb-3 font-semibold text-N-700'>
              Based on customer dispatch date (Push API)
            </h3>

            <div className='grid grid-cols-[180px] gap-4 text-sm font-medium text-N-700 mb-2'>
              <span>Order type</span>
            </div>

            {dispatchRows.map((sla: any, index: number) => (
              <div
                key={`dispatch-${index}`}
                className='grid grid-cols-[180px] gap-4 text-sm text-N-700 py-1'>
                <span>{getOrderType(sla)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <Drawer
      isActive={isActive}
      onOverlayClick={onCloseClick}
      onCloseClick={onCloseClick}
      title={viewPartnerDetails.partnerName}
      objectAfterTitle={
        <div className='pl-[14px]'>
          <Badge
            appearance={viewPartnerDetails.status ? 'success' : 'error'}
            labelValue={viewPartnerDetails.status ? 'ACTIVE' : 'IN-ACTIVE'}
          />
        </div>
      }>
      <div className={AddPartnerClasses}>
        {(getPartnerByIdIsLoading || getPartnerIntegrationByIdIsLoading) && (
          <div className='flex w-full h-full items-center justify-center bg-N-800 absolute z-[1] left-0 top-0 bg-opacity-20 cursor-not-allowed'>
            <JsonLoader size='xs' />
          </div>
        )}

        <div className='flex w-full'>
          <span className='text-N-700 text-lg font-bold w-36'>
            Partner Info
          </span>

          <Button
            onClick={() => {
              onCloseClick()
              setUpdatePartnerDrawerIsOpen(true)
            }}
            size='xs'
            appearance='dull'>
            <i className='ri-edit-line'></i>
          </Button>

          <Button
            onClick={() => {
              setDeletePartnerPopOutIsOpen(true)
            }}
            size='xs'
            appearance='danger'
            className='ml-4'>
            <i className='ri-delete-bin-6-line'></i>
          </Button>
        </div>

        <div className='flex w-full items-center pt-[18px]'>
          {ViewSection('Partner Name:', viewPartnerDetails.partnerName, 'left')}
          {ViewSection(
            'Partner Code:',
            viewPartnerDetails.partnerCode,
            'right',
          )}
        </div>

        <div className='flex w-full items-center pt-[14px]'>
          {ViewSection(
            'Contact Person:',
            viewPartnerDetails.contactPerson,
            'left',
          )}
          {ViewSection(
            'Contact Email:',
            viewPartnerDetails.contactEmail,
            'right',
          )}
        </div>

        <div className='flex w-full items-center pt-[14px]'>
          {ViewSection(
            'Support Email:',
            viewPartnerDetails.supportEmail,
            'left',
          )}
          {ViewSection('Phone No:', viewPartnerDetails.phoneNo, 'right')}
        </div>

        <div className='flex w-full items-center pt-[14px]'>
          {ViewSection(
            'Street Address:',
            viewPartnerDetails.streetAddress,
            'full',
          )}
        </div>

        <div className='flex w-full items-center pt-[14px]'>
          {ViewSection('Suburb:', viewPartnerDetails.suburb, 'left')}
          {ViewSection('State:', viewPartnerDetails.state, 'right')}
        </div>

        <div className='flex w-full items-center pt-[14px]'>
          {ViewSection('Postal Code:', viewPartnerDetails.postalCode, 'left')}
          {ViewSection(
            'Country:',
            viewPartnerDetails.country?.label || '-',
            'right',
          )}
        </div>

        {ViewSLAs()}

        <div className='w-full pt-10'>
          <div className='flex items-center'>
            <h2 className='text-lg font-bold text-N-700'>Integration</h2>
            <p className='text-sm text-N-500 pl-1'>
              ({newIntegrations.length} integration)
            </p>

            <Button
              onClick={() => {
                onCloseClick()
                setPartnerIntegrationDrawerIsOpen(true)
              }}
              size='xs'
              appearance='dull'
              className='ml-6'>
              <i className='ri-edit-line'></i>
            </Button>
          </div>

          {newIntegrations.length > 0 &&
            newIntegrations.map((integration: any, idx: any) => (
              <IntegrationPanelView
                IntegrationData={integration}
                setNewIntegrations={setNewIntegrations}
                newIntegrations={newIntegrations}
                key={idx}
                indexValue={idx}
              />
            ))}
        </div>
      </div>
    </Drawer>
  )
}

ViewPartner.defaultProps = {
  className: undefined,
}

export default ViewPartner